import { useAuth0 } from '@auth0/auth0-react'
import React, { useEffect } from 'react'
import Loader from '../../../components/UI/Loader/Loader';
import { useSearchParams } from 'react-router-dom';

const Login = () => {
    
    const { loginWithRedirect } = useAuth0();
    const [searchParams] = useSearchParams();
    const step = searchParams.get('step');

    useEffect(() => {
        handleLogin()
    }, [])
    
    const handleLogin = () => {
        loginWithRedirect({
            authorizationParams: {
                redirect_uri: process.env.REACT_APP_AUTH0_BASE_URL,
                step: step ? step : "",
            },
        });
    };

    return (
        <div><Loader /></div>
    )
}

export default Login